import gql from 'graphql-tag';

import type { OnDemandCourseMaterialItemsV1 } from 'bundles/naptimejs/resources/__generated__/OnDemandCourseMaterialItemsV1';
import type { OnDemandCourseMaterialsV2Connection } from 'bundles/naptimejs/resources/__generated__/OnDemandCourseMaterialsV2';

export type { OnDemandCourseMaterialsV2LearnerQueryVariables as GetSkillAreaCourseItemsQueryVariables } from 'bundles/naptimejs/resources/__generated__/OnDemandCourseMaterialsV2';

export type GetSkillAreaCourseItemsQueryData = {
  OnDemandCourseMaterialsV2: {
    learner:
      | (OnDemandCourseMaterialsV2Connection & {
          linked: {
            onDemandCourseMaterialItemsV2: OnDemandCourseMaterialItemsV1[];
          };
        })
      | null;
  } | null;
};

/* eslint-disable graphql/template-strings */
const GetSkillAreaCourseItemsQuery = gql`
  query GetSkillAreaCourseItemsQuery($courseId: ID!, $learnerId: ID!) {
    OnDemandCourseMaterialsV2 @naptime {
      learner(courseId: $courseId, learnerId: $learnerId, includes: "items", showLockedItems: true) {
        linked {
          onDemandCourseMaterialItemsV2 {
            id
            contentSummary
          }
        }
      }
    }
  }
`;
/* eslint-enable graphql/template-strings */

export default GetSkillAreaCourseItemsQuery;
